import React, { useState, useEffect } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  CardBody,
  CardFooter,
  CardHeader,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  CustomInput
} from "reactstrap";
import ProfileDetail from "../Settings/ProfileDetail";
import _ from "lodash";
import PatientList from "../Admin/AdminSharedAccount/PatientList";
import { useDispatch } from "react-redux";
import { useFetch2 } from "components/utils/authenticatedHook";
function SharedDetails(props) {
  const {
    row,
    users,
    userInputChange,
    expectationInputChange,
    expectations
  } = props;
  const dontChange = true;
  const [{ response, error, isLoading }, doFetch, sendError] = useFetch2(null);
  const [activeTab, setActiveTab] = useState("1");
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  const {
    autoAddExpectations = false,
    autoAddPatients = false,
    autoAddAllPatients = false,
    _id: userId
  } = row;
  useEffect(() => {
    dispatch({
      type: "DO_REMOVE_PROFILE_DATA"
    });
  }, [dontChange]);
  useEffect(() => {
    return () => {
      dispatch({
        type: "DO_REMOVE_PROFILE_DATA"
      });
    };
  }, []);
  // when Assign Patients tab opens or search changes, fetch server-side patient list
  useEffect(() => {
    if (props.handleAllPatients && activeTab === "1") {
      const handler = setTimeout(() => {
        props.handleAllPatients(row._id, search);
      }, 300);
      return () => clearTimeout(handler);
    }
  }, [activeTab, search]);
  const submitAutoAdd = e => {
    const target = e.target;
    const isCheck = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    doFetch({
      url: `/staff/${row.user._id}/auto-addfunction?${name}=${isCheck}`,
      method: "GET"
    });
  };

  const updateAutoAddAllPatients = staffId => {
    dispatch({
      type: "DO_ADD_ALL_PATIENTS",
      payload: { staffId: staffId }
    });
  };




  return (
    <div>
      <Nav tabs className="justify-content-center">
        <NavItem>
          <NavLink
            className={activeTab == "1" ? "active" : ""}
            onClick={() => setActiveTab("1")}
          >
            ASSIGN PATIENTS
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab == "2" ? "active" : ""}
            onClick={() => setActiveTab("2")}
          >
            {row.lname} {row.fname} PROFILE
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          {" "}
          <Row>
            <Col>
              <Card body className="shared-account-card">
                <CardTitle className="text-center">
                  Pick Patient to Assign
                </CardTitle>
                <div className="text-center">
                  <CustomInput
                    type="switch"
                    id="autoAddPatient"
                    defaultChecked={autoAddPatients}
                    name="autoAddPatients"
                    onChange={submitAutoAdd}
                    label="Auto Add New Patients Created"
                  />
                </div>

                <Form>
                  <FormGroup>
                    <Row className="mb-2">
                      <Col md={{ size: 8, offset: 2 }}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search patients by name, email or username "
                          value={search}
                          onChange={e => setSearch(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row className="ml-4">
                      <CustomInput
                        type="checkbox"
                        id="addAll"
                        onChange={e => updateAutoAddAllPatients(row.user._id)}
                        label="Add All"
                      />
                    </Row>

                    <PatientList
                      data={props.allStaffPatientList || []}
                      sizePerPage={10}
                      page={1}
                      totalSize={props.allStaffPatientList ? props.allStaffPatientList.length : 0}
                      loading={props.ongoingAssignedUserRequest}
                      readingSubTypes={[]}
                      profileOwner={[]}
                      userInputChange={userInputChange}
                      staffId={row._id}
                      isAdmin={false}
                    />
                  </FormGroup>
                </Form>
              </Card>
            </Col>            
          </Row>
        </TabPane>
        <TabPane tabId="2">
          {" "}
          <Row className="pt-2" style={{margin:15}}>
            {activeTab === "1" && (
              <ProfileDetail
                hideTitle={true}
                enableUserEdit={false}
                currentUserId={row.user._id}
              />
            )}
            {activeTab === "2" && (
              <ProfileDetail
                hideTitle={true}
                enableUserEdit={false}
                currentUserId={row.user._id}
              />
            )}
          </Row>
        </TabPane>
      </TabContent>
    </div>
  );
}

export default SharedDetails;
